import moment from 'moment';
import TimeEntry from './timeentry.model';
import _ from 'lodash';

export default class
{

    constructor() {
        this.dataDirty = false;
        this.timeEntries = [];
        this.info = {};
        this.dateRange = [];
        this.status = '';
    }

    populateTimesheet(timesheetData, settingsService, user) {
        this.startDate = timesheetData.startDate;
        this.endDate = timesheetData.endDate;
        this.status = timesheetData.status;
        this.availableChargeCodes = user.availableChargeCodes;
        this.approver = timesheetData.approver;
        this.approvedDate = timesheetData.approvedDate
        this.submitDate = timesheetData.submitDate
        this.startDateRange = moment(timesheetData.startDate).format('MMM-DD') + ' - ' + moment(timesheetData.endDate).format('MMM-DD');
        this.id = timesheetData.id;
        this.settingsService = settingsService;

        let workingDays = this.countDays(moment(this.startDate), moment(this.endDate), moment(user.startDate), true);
        let workingDaysSoFar = workingDays
        let workingDaysSoFarYear = this.countDays(moment().startOf('year'), moment(new Date()), moment(user.startDate));
        let weekendDays = this.countWeekends(moment(this.startDate), moment(this.endDate), moment(user.startDate));
        let weekendDaysSoFar = weekendDays
        let weekendDaysSoFarYear = this.countWeekends(moment().startOf('year'), moment(new Date()), moment(user.startDate));
        let holidays = this.countHolidays(moment(this.startDate), moment(this.endDate), moment(user.startDate));
        let holidaysSoFar = holidays
        let holidaysSoFarYear = this.countHolidays(moment().startOf('year'), moment(new Date()), moment(user.startDate));
        let holidaysOnWeekend = this.countWeekendHolidays(moment(this.startDate), moment(this.endDate), moment(user.startDate));
        let holidaysOnWeekendSoFar = holidaysOnWeekend
        let holidaysOnWeekendSoFarYear = this.countWeekendHolidays(moment().startOf('year'), moment(new Date()), moment(user.startDate));

        // If current active timesheet, use today as enddate instead of timesheet enddate
        if (moment(this.endDate).isSameOrAfter(new Date())) {
          workingDaysSoFar = this.countDays(moment(this.startDate), moment(new Date()), moment(user.startDate))
          weekendDaysSoFar = this.countWeekends(moment(this.startDate), moment(new Date()), moment(user.startDate));
          holidaysSoFar = this.countHolidays(moment(this.startDate), moment(new Date()), moment(user.startDate));
          holidaysOnWeekendSoFar = this.countWeekendHolidays(moment(this.startDate), moment(new Date()), moment(user.startDate));
        }

        let wkDays = 0;
        let wkDaysSoFar = 0
        let wkDaysSoFarYear = 0

        if(settingsService.isExcludeHolidays() && settingsService.isExcludeWeekends()) {
          wkDays = workingDays - weekendDays;
          wkDaysSoFar = workingDaysSoFar - weekendDaysSoFar;
          wkDaysSoFarYear = workingDaysSoFarYear - weekendDaysSoFarYear;
        } else if(settingsService.isExcludeWeekends()) {
          wkDays = workingDays - weekendDays;
          wkDaysSoFar = workingDaysSoFar - weekendDaysSoFar;
          wkDaysSoFarYear = workingDaysSoFarYear - weekendDaysSoFarYear;
        } else if(settingsService.isExcludeHolidays()) {
          wkDays = workingDays - holidays;
          wkDaysSoFar = workingDaysSoFar - holidaysSoFar;
          wkDaysSoFarYear = workingDaysSoFarYear - holidaysSoFarYear;
        }

        this.info.timesheetHours = wkDays * settingsService.getWorkingHoursPerDay();

        this.info.weekends = weekendDays / 2;
        this.info.holidays = holidays;
        this.info.expectedHoursSoFar = wkDaysSoFar * 8

        // Arguably, this doesn't belong here since its for the year and not the current timesheet.
        // But all the calculation functions are here, so its convenient
        this.info.expectedHoursSoFarYear = wkDaysSoFarYear * 8

        for(let entryIndex = 0; entryIndex < timesheetData.timeEntries.length; entryIndex++) {
            let entry = timesheetData.timeEntries[entryIndex];
            let te = new TimeEntry(entry.date, entry.chargeCode);
            if(entry.hours === null) {
              te.hours = undefined;
            } else {
              te.hours = entry.hours;
            }

            // te.reason = entry.reason;
            te.type = entry.type;
            te.timeEntryChanges = entry.timeEntryChanges;
            te.timeEntryNotes = entry.timeEntryNotes;

            this.timeEntries.push(te);
        }

        this.calculateTimeEntryBasedInfo()
    }

    /**
     * Updates Time Entry based info properties.
     */
    calculateTimeEntryBasedInfo() {
      let billableHours = 0
      let nonbillableHours = 0
      let leaveHours = 0

      this.timeEntries.forEach(te => {
        if (te.chargeCode) {
          // Billable hours
          if (te.chargeCode.billable) {
            billableHours += te.hours || 0
          }
          // Leave hours
          else if (te.chargeCode.leaveType) {
            leaveHours += te.hours || 0
          }
          // Nonbillable hours
          else {
            nonbillableHours += te.hours || 0
          }
        }
      })

      // Add helpful time entry based data to info obj
      this.info.billableHours = billableHours
      this.info.nonbillableHours = nonbillableHours
      this.info.leaveHours = leaveHours

    }

    addChargeCode(chargeCode){
        for(let i=0; i<this.dateRange.length; i++) {
            this.timeEntries.push(new TimeEntry(this.dateRange[i], chargeCode));
        }
    }

    getTimeEntry(chargeCode,date) {
        for(let q=0;q<this.timeEntries.length;q++){
            let te = this.timeEntries[q];
            let d = moment(te.date).format('YYYY-MM-DD');
            if(moment(d).isSame(moment(date)) && te.chargeCode.name === chargeCode.name){
                return te;
            }
        }
    }

    timeEntriesForChargeCode(chargeCodeName) {
        let entries = [];

        for(let q=0;q<this.timeEntries.length;q++){
            let te = this.timeEntries[q];
            if(te.chargeCode.name === chargeCodeName) {
                entries.push(te);
            }
        }

        return entries;
    }

    getTimeEntriesForDate(date) {
        let entries = [];

        for(let q=0;q<this.timeEntries.length;q++){
            let te = this.timeEntries[q];
            let d = moment(te.date).format('YYYY-MM-DD');
            if(moment(d).isSame(moment(date))){
                entries.push(te);
            }
        }

        return entries;
    }

  getNonLeaveTimeEntriesForDate(date) {
    let entries = [];

    for(let q=0;q<this.timeEntries.length;q++){
      let te = this.timeEntries[q];
      let d = moment(te.date).format('YYYY-MM-DD');

      if(moment(d).isSame(moment(date)) && !te.chargeCode.leaveType){
        entries.push(te);
      }
    }

    return entries;
  }

  getNonAutoBalanceLeaveTimeEntriesForDate(date) {
    let entries = [];

    for(let q=0;q<this.timeEntries.length;q++){
      let te = this.timeEntries[q];
      let d = moment(te.date).format('YYYY-MM-DD');

      if(moment(d).isSame(moment(date)) && te.chargeCode.id !== window.Utilities.AUTO_BALANCE_CHARGE_CODE_ID() && te.chargeCode.leaveType){
        entries.push(te);
      }
    }

    return entries;
  }

  getNonAutoBalanceTimeEntriesForDate(date) {
    let entries = [];

    for(let q=0;q<this.timeEntries.length;q++){
      let te = this.timeEntries[q];
      let d = moment(te.date).format('YYYY-MM-DD');

      if(moment(d).isSame(moment(date)) && te.chargeCode.id !== window.Utilities.AUTO_BALANCE_CHARGE_CODE_ID()){
        entries.push(te);
      }
    }

    return entries;
  }



    countDays(fromDate, toDate, userStartDate, addToDateRange) {
      let startDate = moment(fromDate);
      let dayCnt = 0;

      while (startDate.isSameOrBefore(moment(toDate))) {
        if (addToDateRange) {
          this.dateRange.push(startDate);
        }

        if(startDate.isSameOrAfter(moment(userStartDate))){
            dayCnt++;
        }

        startDate = moment(startDate).add(1,'days');
      }

      return dayCnt;
    }

    countWeekends(fromDate, toDate, userStartDate) {
      let currentDate = moment(fromDate);
      let weekendCnt = 0;

      while (currentDate.isSameOrBefore(moment(toDate))) {
        let isWeekend = (currentDate.weekday() === 0 || currentDate.weekday() == 6);
        if(isWeekend && currentDate.isSameOrAfter(moment(userStartDate))) {
          weekendCnt++;
        }
        currentDate = moment(currentDate).add(1,'days');
      }

      return weekendCnt;
    }

    countHolidays(fromDate, toDate, userStartDate) {
      let holidays = this.settingsService.getHolidays();
      let currentDate = moment(fromDate);
      let holidayCnt = 0;

      while (currentDate.isSameOrBefore(moment(toDate))) {
        let isHoliday = holidays[moment(currentDate).format('MM/DD')];
        if(isHoliday && currentDate.isSameOrAfter(moment(userStartDate))) {
          holidayCnt++;
        }
        currentDate = moment(currentDate).add(1,'days');
      }

      return holidayCnt;
    }

    countWeekendHolidays(fromDate, toDate, userStartDate) {
      let holidays = this.settingsService.getHolidays();
      let currentDate = moment(fromDate);
      let weekendHolidayCnt = 0;

      while (currentDate.isSameOrBefore(moment(toDate))) {
        let isHoliday = holidays[moment(currentDate).format('MM/DD')];
        let isWeekend = (currentDate.weekday() === 0 || currentDate.weekday() == 6);

        if(isHoliday && isWeekend && currentDate.isSameOrAfter(moment(userStartDate))) {
          weekendHolidayCnt++;
        }
        currentDate = moment(currentDate).add(1,'days');
      }

      return weekendHolidayCnt;
    }


}



// WEBPACK FOOTER //
// ./client/pages/timesheet/services/timesheets/timesheet.model.js